import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-link',
  templateUrl: './edit-link.component.html',
  styleUrls: ['./edit-link.component.scss']
})
export class EditLinkComponent implements OnInit {
  @Input() linkInfo: any;
  copyOfLinkInfo: any;

  constructor(
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.copyOfLinkInfo = {...this.linkInfo};
    this.copyOfLinkInfo.copyDetail = [...this.linkInfo.detail];
  }


  sendData(): any {
    this.copyOfLinkInfo.imgActivo = this.copyOfLinkInfo.imgActivo === false ? 0 : 1;
    this.copyOfLinkInfo.urlExterno = 0;
    this.copyOfLinkInfo.copyDetail.forEach(item => {
      item.imgActivo = item.imgActivo === false ? 0 : 1;
      item.urlExterno = 0;
    });
    const childrenArr = this.copyOfLinkInfo.copyDetail.map(item => {
      return {
        id: item.id ? item.id : 0,
        value: item.value,
        img: item.img,
        url: item.url,
        order: item.order,
        urlExterno: item.urlExterno,
        imgActive: item.imgActivo
      };
    });
    const dataToSend = {
      id: this.copyOfLinkInfo.id,
      url: this.copyOfLinkInfo.url,
      value: this.copyOfLinkInfo.value,
      img: this.copyOfLinkInfo.img,
      urlExterno: this.copyOfLinkInfo.urlExterno,
      imgActive: this.copyOfLinkInfo.imgActivo,
      headerItems: childrenArr
    };

    this.activeModal.close(dataToSend);
  }

  createLinkFields() {
    this.copyOfLinkInfo.copyDetail.push({
      value: '',
      url: '',
      order: this.copyOfLinkInfo.copyDetail.length + 1,
      urlExterno: false,
      imgActivo: false
    });
  }


  deleteLinkField(i: number): any {
    this.copyOfLinkInfo.copyDetail.splice(i, 1);
  }

  functionToValidateEmptyFields(obj): any {
    return obj.value.length > 0 && obj.url.length > 0;
  }

  validateEmptyFields(): any {
    return this.copyOfLinkInfo.copyDetail.every(this.functionToValidateEmptyFields);
  }


}
